<template>

<div>
  
      <div class="hidden sm:block">
          <header class="header-selected header_top">
              <button @click="goHome" class="header-logo" aria-label="homepage">
                  <img class="object-cover w-auto h-20" src="../../assets/vqvtest.png">
              </button>
              <nav class="main-nav">
              <ul class="nav__list">
                  <li class="nav__list-item"><button class="nav__link">Home</button></li>
                  <li class="nav__list-item">
                  <button class="nav__link">About</button>
                  </li>
                  <li class="nav__list-item">
                  <button  class="nav__link">Services</button>
                  </li>
                  <li class="nav__list-item"><button class="nav__link">Contact</button></li>
              </ul>
              </nav>
          </header>
      </div>

      <div class="top-hero">

          <div class="absolute inset-0 " id="particles-js"></div>
              <div class="relative h-screen sm:h-full">

                  <div aria-hidden="true" class="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0">
                    <svg class="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1463 360">
                      <path class="text-blue-800 text-opacity-20" fill="currentColor" d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z" />
                      <path class="text-blue-900 text-opacity-40" fill="currentColor" d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z" />
                    </svg>
                  </div>

                  <div class="sm:pt-24 mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">


                    <div class="space-y-12">
                        <div class="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
                            <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl"></h2>
                        </div>
                    </div>
                      

                  <div class="mx-auto py-8 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
                      <div class="space-y-12">
                          <ul role="list" class="space-y-12 sm:grid sm:grid-cols-2 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 items-center justify-items-center">
                              <li class="col-span-full">
                                  <div class="space-y-4">
                                      <div class="aspect-w-3 aspect-h-2 zoomIn text-white">
                                          <img class="object-cover shadow-lg rounded-lg border-2 border-gray-50" :src="imageUrl" alt="">
                                      </div>
                                  </div>
                              </li>
                          </ul>

                      </div>
                  </div>

                      
                  </div> 

                  <div class="relative overflow-hidden">

                      <div class="my-8 mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
                          <p class="text-animated from-left uppercase mt-2 text-3xl font-extrabold text-gray-50 sm:text-5xl">
                              {{value}}
                          </p>

                          <div class="relative mt-1">
                              <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                  <div class="w-full border-t border-gray-700"></div>
                              </div>
                              <div @click="showContactModal" class="relative flex justify-center cursor-pointer">
                                  <span class="px-2 py-1.5 bg-gradient-to-r from-orange-500 to-orange-800 text-sm rounded-md text-white font-bold"> Contact Us </span>
                              </div>
                          </div>

                          <p class="whitespace-pre-line font-sans mt-4 max-w-md mx-auto text-base text-gray-300 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                              {{description}}.<br />
                              <!-- For more information please  <br /> -->
                          </p>
                          

                      </div>

                  </div>


          </div>
      </div>

              <!-- modal -->
        <v-dialog v-model="displayModal" v-if="displayModal" width="900">

            <div class="bg-gray-900 bg-opacity-25 py-4 rounded-md px-4 ">
                <getStarted></getStarted>
            </div>

        </v-dialog>

</div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>

<script>
export default {
  data() {
    return {
        value: this.$route.params.id,
        description: this.$route.params.desc,
        displayModal: false,
    };
  },

computed: {
    imageUrl() {
        return this.$route.params.image
    },

    textAnimated(){

      const sliders = document.querySelectorAll(".text-animated");
      const appearOptions = {
         threshold: 0,
         //rootMargin: "-100px 0px 0px 0px"
      };

      const appearOnScroll = new IntersectionObserver(function(entries,appearOnScroll) 
        {
          entries.forEach(entry => {
            if (!entry.isIntersecting) {
              return
            } else {
              entry.target.classList.add("appear");
              appearOnScroll.unobserve(entry.target);
            }
        });
      },
      appearOptions);

      return sliders.forEach(slider => {
       return appearOnScroll.observe(slider);
      });
    },
},

  mounted() {
    this.textAnimated;
    this.initParticles();
 
  },

  methods: {
    goHome() {
        this.$router.push({ name: "Home" },);
    },

    showContactModal(){
        this.displayModal = true;
    },


    initParticles() {
      if ($('#particles-js').length) {
        particlesJS("particles-js", {
          "particles": {
            "number": {
              "value": 50,
              "density": {
                "enable": true,
                "value_area": 1000
              }
            },
            "color": {
              "value": ["#5507fc"]
            },
            "shape": {
              "type": "circle",
              "stroke": {
                "width": 3,
                "color": "#5507fc"
              },
              "polygon": {
                "nb_sides": 5
              },
              "image": {
                "src": "img/github.svg",
                "width": 100,
                "height": 100
              }
            },
            "opacity": {
              "value": 0.6,
              "random": false,
              "anim": {
                "enable": false,
                "speed": 1,
                "opacity_min": 0.1,
                "sync": false
              }
            },
            "size": {
              "value": 2,
              "random": true,
              "anim": {
                "enable": false,
                "speed": 40,
                "size_min": 0.1,
                "sync": false
              }
            },
            "line_linked": {
              "enable": true,
              "distance": 120,
              "color": "#5507fc",
              "opacity": 0.2,
              "width": 1.6
            },
            "move": {
              "enable": true,
              "speed": 1,
              "direction": "top",
              "random": false,
              "straight": false,
              "out_mode": "out",
              "bounce": false,
              "attract": {
                "enable": false,
                "rotateX": 600,
                "rotateY": 1200
              }
            }
          },
          "interactivity": {
            "detect_on": "canvas",
            "events": {
              "onhover": {
                "enable": true,
                "mode": "grab"
              },
              "onclick": {
                "enable": false
              },
              "resize": true
            },
            "modes": {
              "grab": {
                "distance": 140,
                "line_linked": {
                  "opacity": 1
                }
              },
              "bubble": {
                "distance": 400,
                "size": 40,
                "duration": 2,
                "opacity": 8,
                "speed": 3
              },
              "repulse": {
                "distance": 200,
                "duration": 0.4
              },
              "push": {
                "particles_nb": 4
              },
              "remove": {
                "particles_nb": 2
              }
            }
          },
          "retina_detect": true
        });
      }
    },

    }
};
</script>
<style scoped>


.zoomIn img {
	-webkit-transform: scale(1);
	transform: scale(1);
	-webkit-transition: .3s ease-in-out;
	transition: .3s ease-in-out;
}

.zoomIn:hover img {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}


</style>